import React from 'react';
import { Backdrop, CircularProgress, Typography } from '@material-ui/core';

const Loading = () => {
    return (
        <Backdrop open>
            <CircularProgress />
            <Typography variant='h5' component='div'>
                Laster data...
            </Typography>
        </Backdrop>
    );
};

export default Loading;
